import React from "react";
import { RadixCheckbox } from "../primitives/RadixCheckbox";
import "./smsMarketingOptIn.css";
import { formatter } from "../utility/formatter";
export function SmsMarketingOptIn(_a) {
    var _b, _c;
    var id = _a.id, checked = _a.checked, onCheckedChange = _a.onCheckedChange, _d = _a.disabled, disabled = _d === void 0 ? false : _d;
    var session = typeof window !== "undefined"
        ? window.session
        : undefined;
    var chainName = typeof ((_b = session === null || session === void 0 ? void 0 : session.chain) === null || _b === void 0 ? void 0 : _b.name) === "string" ? session.chain.name : "";
    var privacyPolicyUrl = (typeof ((_c = session === null || session === void 0 ? void 0 : session.store) === null || _c === void 0 ? void 0 : _c.privacy_policy_url) === "string"
        ? session.store.privacy_policy_url.trim()
        : "") || "/policies/privacy";
    return (React.createElement("div", { className: "sms-marketing-opt-in" },
        React.createElement("p", { className: "sms-marketing-opt-in-title" }, "SMS offers"),
        React.createElement(RadixCheckbox, { id: id, checked: checked, onCheckedChange: onCheckedChange, disabled: disabled, label: "Send me messages including special offers from ".concat(formatter.toProperCase(chainName), "."), description: (React.createElement(React.Fragment, null,
                "* By checking this box, you are agreeing to receive SMS messages from ",
                formatter.toProperCase(chainName),
                ". Reply STOP to unsubscribe or HELP for assistance. Message frequency varies and message and data rates may apply.",
                " ",
                React.createElement("a", { href: privacyPolicyUrl, target: "_blank", rel: "noopener noreferrer" }, "Privacy Policy"))) })));
}
